import React from 'react';
import { ModalCloseIcon } from '../../LegacyIcons';

const ModalDialog = ({ children, onClose }) => (
  <div>
    <div className="c-modal-dialog__header">
      <button className="c-modal-dialog__close" onClick={onClose}>
        <span className="u-hide-visually">close</span>
        <ModalCloseIcon size="x-small" />
      </button>
    </div>
    <div className="c-modal-dialog__content">{children}</div>
  </div>
);

export default ModalDialog;
